import axios from 'axios';
import { getAccessToken } from '@/modules/token-refresher';
import router from '@/router';
import ENV_VARS from '@/modules/env-vars';

const ACCESS_TOKEN_KEY = 'X-IS-AT';

var refreshToken = '';

const request = axios.create();

request.defaults.baseURL = 'https://api.init.st/auth/';

function schemaInterceptor(config) {
	var url = config && config.url;
	if (/^\w+:/.test(url)) {
		config.url = url.replace(/^(\w+):\/\//, function (match, schema) {
			schema = schema.toUpperCase();

			if (ENV_VARS.hasOwnProperty(schema) && /^https?:\/\//.test(ENV_VARS[schema])) {
				match = ENV_VARS[schema].replace(/\/$/, '') + '/';
			}

			return match;
		});
	}
	return config;
}

request.interceptors.request.use(schemaInterceptor);

function requestInterceptor(config) {
	if (!refreshToken) {
		return config;
	}
	if (!config) {
		config = {};
	}
	return getAccessToken(refreshToken)
		.then((accessToken) => {
			if (!config.headers) {
				config.headers = {};
			}
			if (!config.headers[ACCESS_TOKEN_KEY]) {
				// Set access token
				config.headers[ACCESS_TOKEN_KEY] = accessToken;
			}
			return config;
		})
		.catch(error => {
			if (error && error.message === 'INVALID_TOKEN') {
				router.push({path: '/logout', query: { destination: router.currentRoute.path, reason: 'unauthorized' }});
			}
			return Promise.reject(error);
		});
}

request.interceptors.request.use(requestInterceptor);

request.interceptors.response.use((response) => {
	return response;
}, (error) => {
	const response = error.response;
	// avoid logging when user types in wrong password
	const wrongPasswordError = response.data && response.data.error && response.data.error.message && response.data.error.message.includes('password');
	// unauthorized send to login
	if (response && response.status === 401 && !wrongPasswordError) {
		router.push({path: '/logout', query: { destination: router.currentRoute.path, reason: 'unauthorized' }});
	}
	return Promise.reject(error);
});

function resolveUrl(path) {
	return request.defaults.baseURL + (path || '');
}

function setBaseUrl(value) {
	if (typeof value === 'string') {
		request.defaults.baseURL = value;
	}
}

function setRefreshToken(token) {
	if (typeof token === 'string') {
		refreshToken = token;
	}
}

export { setBaseUrl, setRefreshToken, resolveUrl, request as default };



// WEBPACK FOOTER //
// ./src/modules/auth-request.js